module.exports = __webpack_public_path__ + "img/job.4ea8d60b.svg";